export default __webpack_public_path__ + "static/media/Logo-IMCAS-07-1.01959c9b.png";